import { createI18n } from 'vue-i18n'
import { defaultLang, i18nMessages } from '@/config/lang'
import store from '@/store'
const locale = store.state.locale
const i18n = createI18n({
  legacy: false,
  locale: locale,
  fallbackLocale: defaultLang,
  messages: i18nMessages,
})
export default i18n